export class CoreError extends Error {
    name: string = 'CoreError';

    code: number;

    // date: Date;

    constructor(code: number, message: string | undefined) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(message);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CoreError);
        }

        this.code = code;
        // this.date = new Date();
    }
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
export class ApiError extends Error {
    name: string = 'ApiError';

    url: string;

    status: number;

    code: number;

    data: any;

    message: string;

    // type: any;

    // reqId: any;

    // date: Date;

    constructor(status: number, code: number, url: string, data: any, message: string) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(message);

        this.message = message;

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        // all api errors are not unexpected error except 500 or 0 (client unkown error)
        if ((code === 500 || code === 0) && Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }

        this.status = status;
        this.code = code;
        this.data = data;
        this.url = url;
    }
}
